import React from 'react';

export const useToggle = (initialState = false): [boolean, () => void] => {
  const [toggleValue, setToggleValue] = React.useState<boolean>(initialState);

  const toggle = React.useCallback(() => {
    setToggleValue((t) => !t);
  }, []);

  return [toggleValue, toggle];
};
